import { Component, Input, OnDestroy, OnInit, inject, input } from '@angular/core';
import {Subscription} from "rxjs";
import {ChipModule} from "primeng/chip";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {DataView, DataViewModule} from "primeng/dataview";
import {SelectModule} from "primeng/select";
import {InputTextModule} from "primeng/inputtext";
import {RatingModule} from "primeng/rating";
import { SlicePipe } from "@angular/common";
import {DialogModule} from "primeng/dialog";
import {ProjectDescriptorUse, WriterStatus} from 'src/app/api/enums';
import {ProjectDetailComponent} from "./project-detail/project-detail.component";
import {DataService} from "../../service/data.service";
import {Utils} from "../../api/utils";
import { ProjectMatchStatus } from 'src/app/api/enums';
import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';

@Component({
    selector: 'project-display',
    imports: [
    ChipModule,
    ButtonModule,
    RippleModule,
    DataViewModule,
    SelectModule,
    InputTextModule,
    RatingModule,
    ProjectDetailComponent,
    DialogModule,
    SlicePipe
],
    templateUrl: './project-display.component.html',
    styleUrl: './project-display.component.scss'
})
export class ProjectDisplayComponent implements OnInit {
    private dataService = inject(DataService);


    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() projectMatch!: ProjectMatchType;

    showDetail: boolean = false;

    readonly projectDisplayMode = input.required<ProjectDescriptorUse>();

    ngOnInit(): void {
        console.log("DISPLAY projectMatch: ", this.projectMatch);
    }

    protected readonly WriterStatus = WriterStatus;
    protected readonly ProjectMatchStatus = ProjectMatchStatus;
    protected readonly Utils = Utils;
    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;
}
